/* BIN EISA Investment theme — mobile menu, and a way to a plan page when the store has no page for it. */
(function () {
  "use strict";

  /* /pages/gold (or /pages/gold-plan) that the store does not have → the same plan page at /search?q=gold-plan.
     The plan cards already link there when no page exists; this covers an address typed or bookmarked by hand. */
  var notFound = document.querySelector("[data-not-found]");
  var plan = notFound && location.pathname.match(/\/pages\/(starter|growth|silver|gold|platinum|elite)(?:-plan)?\/?$/i);
  if (plan) location.replace((notFound.getAttribute("data-search-url") || "/search") + "?q=" + plan[1].toLowerCase() + "-plan");

  function setOpen(open) {
    var nav = document.getElementById("nav");
    var btn = document.getElementById("menu-btn");
    if (!nav || !btn) return;
    nav.classList.toggle("is-open", open);
    btn.setAttribute("aria-expanded", open ? "true" : "false");
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("#menu-btn");
    if (btn) {
      var nav = document.getElementById("nav");
      setOpen(!(nav && nav.classList.contains("is-open")));
      return;
    }
    if (e.target.closest("#nav a")) setOpen(false);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") setOpen(false);
  });
})();
